import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './DividerWithText.css';
const DividerWithText = ({ text, margin, }) => (_jsx(S.Container, Object.assign({ margin: margin }, { children: _jsx(S.Content, { children: text }) })));
export default DividerWithText;
